import gql from "graphql-tag";

import { required } from "api/boundary";

export const CONTACT_FIELD_MIN_FRAGMENT = gql`
  fragment ContactFieldMinDetails on ContactField {
    uuid
    fieldName
    fieldDisplay
  }
`;

// context(alexandrchebotar, 2024-05-30): keep in sync with graphqlQueries/number/fragments.ts
//    Added underscore at the end to prevent duplicating fragments
export const NUMBER_MIN_FRAGMENT_ = {
  query: gql`
    fragment NumberMinFragment_ on Number {
      uuid
      vname
      fromAddr
      profilePicture
      numberType
      backendType
      numberCode
      numberRoute {
        uuid
        fromAddr
      }
    }
  `,
  parse: {
    uuid: required(),
    vname: required(),
    fromAddr: required(),
    numberType: required(),
  },
};
